<template>
  <!-- Added pb-24 md:pb-0 to give space at the bottom for mobile arrows -->
  <div class="custom-swiper-container relative md:pb-0">
    <button
      class="js-swiper-prev swiper-nav-btn absolute z-20 hover:opacity-75 transition-opacity left-4 md:left-96 bottom-4 md:bottom-auto md:top-1/2 md:-translate-y-1/2"
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="24"
          cy="24"
          r="23"
          transform="matrix(-1 0 0 1 48 0)"
          stroke="black"
          stroke-width="2"
        />
        <g clip-path="url(#clip0_2115_70)">
          <path
            d="M27.5469 30.12L21.4402 24L27.5469 17.88L25.6669 16L17.6669 24L25.6669 32L27.5469 30.12Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_2115_70">
            <rect width="32" height="32" fill="white" transform="matrix(-1 0 0 1 39 8)" />
          </clipPath>
        </defs>
      </svg>
    </button>

    <div ref="rootEl" class="js-swiper-container swiper-container" manual-init>
      <div class="swiper-wrapper">
        <slot />
      </div>
    </div>

    <button
      class="js-swiper-next swiper-nav-btn absolute z-20 hover:opacity-75 transition-opacity right-4 md:right-96 bottom-4 md:bottom-auto md:top-1/2 md:-translate-y-1/2"
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="24" cy="24" r="23" stroke="black" stroke-width="2" />
        <g clip-path="url(#clip0_next)">
          <path
            d="M20.4531 17.88L26.5598 24L20.4531 30.12L22.3331 32L30.3331 24L22.3331 16L20.4531 17.88Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_next">
            <rect width="32" height="32" fill="white" transform="translate(9 8)" />
          </clipPath>
        </defs>
      </svg>
    </button>

    <slot name="pagination" />
  </div>
</template>

<script>
import Swiper from 'swiper';

const DEFAULT_BREAKPOINTS = {
  576: { slidesPerView: 2 },
  992: { slidesPerView: 3 },
  1200: { slidesPerView: 4 },
};

const DEFAULT_CONFIG = {
  watchOverflow: true,
  simulateTouch: false,
  slidesPerView: 1,
  spaceBetween: 32,
  speed: 1500,
  autoplay: {
    delay: 45000,
    disableOnInteraction: false,
    loop: true,
  },
  pagination: {
    el: '.custom-swiper-pagination',
    clickable: true,
    bulletActiveClass: 'active-bullet',
    bulletClass: 'custom-bullet',
    renderBullet: function (index, className) {
      return `<span class="${className}"></span>`;
    },
  },
};

export default {
  props: {
    breakpoints: {
      required: false,
      type: Object,
      default: () => DEFAULT_BREAKPOINTS,
    },
    config: { required: false, type: Object, default: () => ({}) },
  },

  data() {
    return {
      swiper: null,
    };
  },

  mounted() {
    this.swiper = new Swiper(this.$refs.rootEl, {
      ...DEFAULT_CONFIG,
      on: {
        slideChange: function () {
          const bullets = this.pagination.bullets;
          if (!bullets) return;

          Array.from(bullets).forEach((bullet, index) => {
            bullet.classList.remove('is-past');
            if (index < this.realIndex) {
              bullet.classList.add('is-past');
            }
          });
        },
        init: function () {
          this.emit('slideChange');
        },
      },
      navigation: {
        nextEl: this.$el.querySelector('.js-swiper-next'),
        prevEl: this.$el.querySelector('.js-swiper-prev'),
      },
      breakpoints: this.breakpoints,
      ...this.config,
    });
  },
};
</script>

<style lang="scss" scoped>
.custom-swiper-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.js-swiper-container {
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  overflow: hidden;
}

.swiper-nav-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: none; /* Changed from 'hidden' to 'none' */
  align-items: center;
  justify-content: center;

  @screen md {
    display: flex;
  }
}

::v-deep .custom-swiper-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-bottom: 2rem;
}

::v-deep .custom-bullet {
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid black;
  background: transparent;
  position: relative;
  cursor: pointer;
  display: inline-block;
  margin-right: 40px;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

::v-deep .custom-bullet:last-child {
  margin-right: 0;
}

::v-deep .custom-bullet:not(:last-child)::after {
  content: '';
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 2px;
  background: black;
}

::v-deep .custom-bullet.active-bullet,
::v-deep .custom-bullet.is-past {
  background: #fc443a;
  border: none;
}
</style>
